import * as React from 'react';
import { connect } from 'react-redux';

import { IDocument } from '../../infrastructure/interfaces';
import CompanyInfoEditorForm from '../DocumentEditor/CompanyInfoEditorForm';
import { productType } from '../../infrastructure/ProductType';
import {
  changeCompanyInfo,
} from '../../actions/actions';

export interface ICompanyInfoChoosingProps {
  document: IDocument;
  changeCompanyInfo(text: string, field: string): void;
}

export interface ICompanyInfoChoosingState extends React.ComponentState {
}
const mapDispatchToProps = (dispatch: any): any => {
  return {
    changeCompanyInfo: (text: string, field: string) => {
      dispatch(changeCompanyInfo(text, field));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CompanyInfoChoosing extends React.Component<any, any> {

  onFieldChange = (field: string, value: string) => {
    this.props.changeCompanyInfo(value, field);
  }

  modalPrompt() {
    if (this.props.document.type === productType.Bulletin){
      return "Please update your branch/account information for footer:"
    } if (this.props.document.type === productType.Postcard) {
      return "Please update your branch/account information for the back of the postcard:"
    } if (this.props.document.type === productType.Poster) {
      return "Please include your company information to be displayed on the poster"
    } else {
      return "Please update your branch/account information for back cover:"
    }
  }

  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            {this.modalPrompt()}
          </div>
          <div className="stepMessage2">
            You can change this selection later
          </div>
        </div>
        <CompanyInfoEditorForm
          onFieldChange={this.onFieldChange}
          document={this.props.document}
          contClassName="stepContent"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps/CompanyInfoChoosing.tsx